import _classCallCheck from "/jenkins/workspace/jenkins-prod-pipelines-LOS-UI-Login-UI-prod-10/packages/react-scripts/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/jenkins/workspace/jenkins-prod-pipelines-LOS-UI-Login-UI-prod-10/packages/react-scripts/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/jenkins/workspace/jenkins-prod-pipelines-LOS-UI-Login-UI-prod-10/packages/react-scripts/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/jenkins/workspace/jenkins-prod-pipelines-LOS-UI-Login-UI-prod-10/packages/react-scripts/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/jenkins/workspace/jenkins-prod-pipelines-LOS-UI-Login-UI-prod-10/packages/react-scripts/node_modules/@babel/runtime/helpers/esm/inherits";
import React, { Component } from 'react';
import Column from './Column';
import TitleBar from './TitleBar';
import Row from './Row';
import Grid from '@material-ui/core/Grid';
import Paper from '@material-ui/core/Paper';
import Collapse from '@material-ui/core/Collapse';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableRow from '@material-ui/core/TableRow';
import TableCell from '@material-ui/core/TableCell';
import { withStyles } from '@material-ui/core/styles';
import { Map } from 'immutable';
import { TableContext } from './context';
var styles = {
  table: {
    tableLayout: 'fixed'
  },
  subHeader: {
    height: 1,
    backgroundColor: '#97a7bd',
    fontWeight: 'bold'
  },
  cell: {
    fontSize: 12,
    height: 30,
    whiteSpace: 'normal',
    textOverflow: 'initial',
    padding: '0px 24px'
  },
  paper: {
    margin: '0 6px 12px 6px'
  }
};

var FormTable =
/*#__PURE__*/
function (_Component) {
  _inherits(FormTable, _Component);

  function FormTable() {
    var _getPrototypeOf2;

    var _this;

    _classCallCheck(this, FormTable);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(FormTable)).call.apply(_getPrototypeOf2, [this].concat(args)));
    _this.state = {
      open: !_this.props.children.get('IsCollapsible')
    };

    _this.toggle = function (bool) {
      if (_this.props.children.get('IsCollapsible')) {
        if (bool === undefined) {
          _this.setState({
            open: !_this.state.open
          });
        } else {
          _this.setState({
            open: bool
          });
        }
      }

      return null;
    };

    _this.renderTableBody = function () {
      return React.createElement(Collapse, {
        in: _this.state.open
      }, React.createElement(Table, {
        className: _this.props.classes.table,
        "data-testid": "FormTable-Table"
      }, React.createElement(TableBody, null, _this.renderSubHeaders(), _this.renderList())));
    };

    return _this;
  }

  _createClass(FormTable, [{
    key: "renderSubHeaders",
    value: function renderSubHeaders() {
      var _this$props = this.props,
          children = _this$props.children,
          classes = _this$props.classes;
      var headerCells = [];
      var valuesFound = false;

      for (var i = 0; i < children.get('Headers').size; i++) {
        var value = children.getIn(['Headers', i, 'Value']);

        if (value) {
          valuesFound = true;
        }

        headerCells.push(React.createElement(TableCell, {
          key: i,
          className: classes.cell
        }, value));
      }

      if (valuesFound) {
        return React.createElement(TableRow, {
          className: classes.subHeader
        }, headerCells);
      }

      return null;
    }
  }, {
    key: "renderList",
    value: function renderList() {
      var children = this.props.children;
      return children.get('Rows').map(function (row, i) {
        if (row) {
          return React.createElement(Row, {
            key: i
          }, row);
        }

        return null;
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props2 = this.props,
          children = _this$props2.children,
          classes = _this$props2.classes;
      var open = this.state.open;
      var context = {
        toggle: this.toggle,
        open: open
      };
      return React.createElement(TableContext.Provider, {
        value: context
      }, React.createElement(Grid, {
        item: true,
        xs: 12,
        "data-testid": "FormTable"
      }, React.createElement(Paper, {
        elevation: 2,
        className: classes.paper
      }, React.createElement(TitleBar, {
        onClick: function onClick() {
          return _this2.toggle();
        },
        collapsible: children.get('IsCollapsible'),
        open: open,
        "data-testid": "FormTable-Title"
      }, children.get('Name')), this.renderTableBody())));
    }
  }]);

  return FormTable;
}(Component);

export default withStyles(styles)(FormTable);